/**
 * Membership access helpers — single source of truth for the activation
 * threshold and membership-error detection shared by ContributionPopup,
 * dashboard hero cards, and search gating.
 */

// Minimum contribution (USD) that activates member search access.
export const ACTIVATION_MIN_AMOUNT = 60;

/**
 * Extracts a human-readable message from an API error.
 * `detail` may be a string or a structured object ({ code, message }).
 */
export const getApiErrorMessage = (error, fallback = 'Something went wrong') => {
  const detail = error?.response?.data?.detail;
  if (typeof detail === 'string' && detail) return detail;
  if (detail && typeof detail === 'object' && detail.message) return detail.message;
  return error?.message || fallback;
};

/**
 * True when an API error means "membership required".
 * Handles axios error objects, raw detail values (string or
 * { code: 'membership_required', ... }), and plain message strings.
 */
export const isMembershipRequiredError = (error) => {
  if (!error) return false;
  if (typeof error === 'string') {
    return error.toLowerCase().includes('membership required');
  }
  const detail = error?.response?.data?.detail ?? error;
  const code = detail && typeof detail === 'object' ? detail.code : undefined;
  const text =
    typeof detail === 'string'
      ? detail
      : (detail?.message || error?.message || '');

  return (
    code === 'membership_required' ||
    error?.response?.status === 403 ||
    text.toLowerCase().includes('membership')
  );
};
